import { RQ } from 'utils';

export default {
  getInfo: async function () {
    let self = this;
    let d = await RQ.mall.get('/api/app/order/agreement', {},{ jsonBody: true, enterprise:'00' });
    if (d && d.code == 0) {
      console.log('///////////',d, d.data);
      self.info = d.data;
    }
  }
};




// WEBPACK FOOTER //
// ./src/module/app/agreement/action.js